import { faBold } from '@fortawesome/pro-light-svg-icons/faBold'
import { faItalic } from '@fortawesome/pro-light-svg-icons/faItalic'
import { faList } from '@fortawesome/pro-light-svg-icons/faList'
import { faListOl } from '@fortawesome/pro-light-svg-icons/faListOl'
import { faUnderline } from '@fortawesome/pro-light-svg-icons'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink'
import { ActionsLitType, GetActionsMenuBarEditorProps } from '../menuBarEditor.types'

export const getActionsMenuBarEditor = ({
  editor,
  theme,
  shouldShowLinkEditor,
  setShowModalLinkEditor,
  enableLinkEditor
}: GetActionsMenuBarEditorProps) => {
  const isActiveButton =
    theme === ThemeMode.DARK ? '_rounded _bg-gray-700' : '_rounded _bg-gray-200'

  const actionsLit: ActionsLitType = [
    {
      onClick: () => editor.chain().focus().toggleBold().run(),
      disabled: !editor?.can().chain().focus().toggleBold().run(),
      className: editor?.isActive('bold') ? isActiveButton : '',
      icon: faBold
    },
    {
      onClick: () => editor.chain().focus().toggleItalic().run(),
      disabled: !editor?.can().chain().focus().toggleItalic().run(),
      className: editor?.isActive('italic') ? isActiveButton : '',
      icon: faItalic
    },
    {
      onClick: () => editor.chain().focus().toggleUnderline().run(),
      className: editor?.isActive('underline') ? isActiveButton : '',
      icon: faUnderline
    }
  ]

  const oderList = [
    {
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      className: editor?.isActive('orderedList') ? isActiveButton : '',
      icon: faListOl
    },
    {
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      className: editor?.isActive('bulletList') ? isActiveButton : '',
      icon: faList
    }
  ]

  if (shouldShowLinkEditor && enableLinkEditor) {
    actionsLit.push({
      onClick: () => setShowModalLinkEditor?.(true),
      className: editor?.isActive('link') ? isActiveButton : '',
      icon: faLink
    })
  }

  return {
    actionsLit,
    oderList
  }
}
